import AccountManagerApi from '@/api/accountManager.api'

const state = {
  accountManagers: []
}

const getters = {
}

const actions = {
  async fetchAccountManagers({ commit }) {
    const response = await AccountManagerApi.getAccountManagers()
    commit('SET_ACCOUNT_MANAGERS', response.data || [])
  },

  async updateAccountManager(context, { data }) {
    const response = await AccountManagerApi.updateAccountManager(data) 
    return response
  },
}

const mutations = {
  SET_ACCOUNT_MANAGERS(state, accountManagers) {
    state.accountManagers = accountManagers
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
